import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { SectionType, StudentSection } from 'libs/domain';

import { StudentSCheduleWidgetMessage } from './student-schedule-widget.constants';

@Component({
  selector: 'mg-student-schedule-widget',
  templateUrl: './student-schedule-widget.component.html',
  styleUrls: ['./student-schedule-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StudentScheduleWidgetComponent {
  // Constants

  public readonly MESSAGES = StudentSCheduleWidgetMessage;
  public readonly SectionType = SectionType;

  // Inputs

  @Input() scheduleItems: StudentSection[];
  @Input() showHomeroom: boolean;
  @Input() bellScheduleEnabledForCurrentUser: boolean = false;

  // Outputs

  @Output() homeroomPressed = new EventEmitter<void>();
  @Output() viewAllPressed = new EventEmitter<void>();
  @Output() scheduleItemPressed = new EventEmitter<{
    isFlexActivity: boolean;
    schedule?: StudentSection;
  }>();

  constructor() {}

  public handleViewAllPressed() {
    this.viewAllPressed.emit();
  }

  public handleScheduleItemPressed(schedule?: StudentSection & { isFlexActivity?: boolean }) {
    this.scheduleItemPressed.emit({
      isFlexActivity: schedule?.type === SectionType.FLEX,
      schedule,
    });
  }

  public handleHomeroomPressed() {
    this.homeroomPressed.emit();
  }
}
